import BillingSettings from '@/pages/settings/billing'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/billing',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId } = Route.useParams()
  return (
    <BillingSettings workspaceSlug={workspaceId} />
  )
}